module.exports = __webpack_public_path__ + "img/home-illustration2.99aec33f.svg";